import { useMemo, useState, useRef, useCallback, useEffect } from 'react'

//* HOCs
import { withDataContext } from 'context'

//* Components
import { ButtonCreateDebateBig, FilterSortBy, ButtonLoadMore } from 'components/common'
import { Tabs } from 'antd'
import TabDebates from '../TabDebates'

const ProfileDebates = ({ isMyProfile, profileDebates, isFilter, ...props }) => {
    const [hasMore, setHasMore] = useState(false)
    const [activeKey, setActiveKey] = useState('debates');

    const checkHasMore = (key) => {
        setActiveKey(key)
        setHasMore(profileDebates[key]?.length < profileDebates[`${key}Total`])
    }

    useEffect(() => {
        checkHasMore(activeKey)
    }, [profileDebates])

    const loadMore = useRef()
    const tabChangeRef = useRef()

    const tabChange = useCallback((activeKey) => {
        tabChangeRef.current(activeKey)
    }, [])

    const handleLoadMore = useCallback(() => {
        loadMore.current(profileDebates[activeKey]?.length, activeKey)
    }, [activeKey, profileDebates])


    return useMemo(() => {
        if (isMyProfile) {
            return (
                <>
                    <div className='debate-section'>
                        <Tabs activeKey={activeKey} onChange={checkHasMore} onTabClick={tabChange}>
                            <Tabs.TabPane tab={`My Debates`} key={'debates'}>
                                {profileDebates.debates.length > 0 ? (
                                    <TabDebates debates={profileDebates.debates} />
                                ) : (
                                    <ButtonCreateDebateBig className='profile' content='Create Debate' />
                                )}
                            </Tabs.TabPane>
                            <Tabs.TabPane tab={'Participating'} key={'participants'}>
                                <TabDebates debates={profileDebates.participants} />
                            </Tabs.TabPane>
                            <Tabs.TabPane tab={'Favorite'} key={'favorites'}>
                                <TabDebates debates={profileDebates.favorites} />
                            </Tabs.TabPane>
                            <Tabs.TabPane tab={'Drafted debates'} key={'draftDebates'}>
                                <TabDebates debates={profileDebates.draftDebates} />
                            </Tabs.TabPane>
                        </Tabs>
                        <FilterSortBy
                            handleFunc={'getProfileDebates'}
                            activeKey={activeKey}
                            isMyProfile={isMyProfile}
                            loadMore={loadMore}
                            tabChange={tabChangeRef}
                        />
                    </div>
                    {hasMore && (
                        <ButtonLoadMore
                            onClick={handleLoadMore}
                            className='align-center load-more-btn'
                            text='Load more'
                        />
                    )}
                </>
            )
        } else {
            return (
                <>
                    <div className='debate-section'>
                        <Tabs activeKey={activeKey} onChange={checkHasMore} onTabClick={tabChange}>
                            <Tabs.TabPane tab={`Debates`} key={'debates'}>
                                <TabDebates debates={profileDebates.debates} />
                            </Tabs.TabPane>
                            <Tabs.TabPane tab={`Participating`} key={'participants'}>
                                <TabDebates debates={profileDebates.participants} />
                            </Tabs.TabPane>
                        </Tabs>
                        {(profileDebates.debates.length > 0 || profileDebates.participants.length > 0 || isFilter) && (
                            <FilterSortBy
                                handleFunc={'getProfileDebates'}
                                activeKey={activeKey}
                                isMyProfile={isMyProfile}
                                profileId={props.profileId}
                                loadMore={loadMore}
                                tabChange={tabChangeRef}
                            />
                        )}
                    </div>
                    {hasMore && (
                        <ButtonLoadMore
                            onClick={handleLoadMore}
                            className='align-center load-more-btn'
                            text='Load more'
                        />
                    )}
                </>
            )
        }
    }, [profileDebates, isMyProfile, activeKey, isFilter, hasMore])
}

export default withDataContext(ProfileDebates, ['profileDebates', 'isFilter'])
